import React from 'react'
import { SvgIcon } from '@mui/material'

export const SeenStatusIcon = props => (
  <SvgIcon viewBox="0 0 20 20" sx={{ color: 'secondary.main' }} {...props}>
    <path d="m9.5 11.5-1 1.08 2.17 2.09v.08l8.41-8.42L18 5.25l-7.33 7.33L9.5 11.5Zm-4.42 3.17v.08l8.42-8.42-1.08-1.08-7.34 7.33L2 9.5.92 10.58l4.16 4.09Z" />
  </SvgIcon>
)
